import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CURRENCY, PRICE, PRICE_VALUE } from '../data/config';
import { trackEvent } from '../utils/metaPixel';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-900/95 px-4 py-3 backdrop-blur transition-transform duration-200 ease-out lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-262" data-mp="3hekhkafthtlr">
      <div className="flex items-center justify-between gap-4" data-id="element-263" data-mp="3qgaa5jlfqyl4">
        <div data-id="element-264" data-mp="210asfe3r40tv">
          <p className="text-sm font-extrabold tracking-tight text-white" data-id="element-265" data-mp="20zsrw5a230g5">{PRICE}</p>
          <p className="text-[11px] text-white/45" data-id="element-266" data-mp="1w1hghq444hvt">Libro + 5 bonos</p>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
        value: PRICE_VALUE,
        currency: CURRENCY
      })} className="whitespace-nowrap rounded-full bg-accent px-5 py-3 text-xs font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-267" data-mp="1w3ki77emnzgd">
          Ir al pago seguro
        </a>
      </div>
    </div>;
}